'use client'

import { useMounted } from '@mentora/app-shared/use-mounted'
import { Button, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@mentora/ui-components'
import { Moon, Sun } from 'lucide-react'
import { useTheme } from 'next-themes'

const iconClass = 'size-5'

export function ThemeToggle() {
  const mounted = useMounted()
  const { theme, setTheme } = useTheme()

  if (!mounted) {
    return (
      <div
        className="size-10 shrink-0 animate-pulse rounded-md bg-muted"
        aria-hidden
      />
    )
  }

  const isDark = theme === 'dark'

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            type="button"
            variant="ghost"
            size="icon"
            className="size-10 shrink-0 text-muted-foreground hover:text-foreground"
            onClick={() => setTheme(isDark ? 'light' : 'dark')}
            aria-label={
              isDark ? 'Switch to light theme' : 'Switch to dark theme'
            }
          >
            {isDark
              ? (
                  <Sun className={iconClass} aria-hidden />
                )
              : (
                  <Moon className={iconClass} aria-hidden />
                )}
          </Button>
        </TooltipTrigger>
        <TooltipContent side="bottom">
          {isDark ? 'Light theme' : 'Dark theme'}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
